import { useEffect, useState } from 'react';
import { getISTParts } from '../lib/shows';

export function useIST() {
  const [parts, setParts] = useState(() => getISTParts());

  useEffect(() => {
    const t = setInterval(() => setParts(getISTParts()), 1000);
    return () => clearInterval(t);
  }, []);

  return parts;
}
